import { usePage } from '@inertiajs/inertia-vue3';
import { computed, watch } from 'vue';
import events from '@/helpers/events';
import dayjs from 'dayjs';

const { on, once, off, emit } = events();

let expiration;

setInterval(() => {
  if (!expiration || dayjs(expiration).isAfter())
    return;

  emit('expired');
}, 1000);

on('expired', () => {
  expiration = null;
});

export default function useCart() {
  const cart = computed(() =>
    usePage().props.value.cart
  );

  watch(() => cart.value, cart => {
    expiration = cart?.expired_at;
  }, { immediate: true });

  return {
    cart,
    on,
    once,
    off,
  };
}
